<div class="bg-default rounded-lg p-4 border border-gray-200 {{ containerClass }}">
  <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3" [class.mb-3]="showExpandedContent && value">
    <div class="flex items-start sm:items-center gap-3">
      <mat-icon [ngClass]="iconColorClass" class="mt-1 sm:mt-0">{{ icon }}</mat-icon>
      <div>
        <h4 class="font-medium text-gray-800">{{ title }}</h4>
        <p class="text-sm text-gray-600">{{ description }}</p>
        @if(tags?.length){
        <div class="flex flex-wrap gap-2 mt-1">
          @for(tag of tags; track tag){
          <span class="px-1 rounded text-xs font-medium uppercase"
            [ngClass]="getTagClass(tag)">
            {{ getTagLabel(tag) }}
          </span>
          }
        </div>
        }
      </div>
    </div>
    <mat-slide-toggle
      [checked]="value"
      [disabled]="disabled"
      (change)="onToggleChange($event)"
      color="primary"
      class="flex-shrink-0">
    </mat-slide-toggle>
  </div>
  
  <div *ngIf="showExpandedContent && value" class="pt-3 border-t border-gray-200">
    <ng-content></ng-content>
  </div>
</div>